module.exports = {
    aggregatorTitle:'聚合媒体营销',
    sumOfToday:'昨日总和',
    cost:'花费',
    dashboard:'大盘分析',
    report:'明细报告',
    creative:'广告素材',
    setting:'设置',
    performanceOverview:'数据概览',
    basicInformation:'基本信息',
    dataView:'数据视图',
    trackingStatistics:'统计数据',
    filters:'筛选',
    timeIntervel:'时间分组',
    dateRange:'时间区间',
    addNew:'新增',
    importAffiliate:'导入渠道',
    searchByCreativeName:'按广告素材名称搜索',
    SearchByAffID:'按Aff ID搜索',
    tipsMap:{
        tips1:'没有找到当前的Aff ID，请填写正确的Aff ID',
        tips2:'当前Aff ID已存在，不能再次创建',
        tips3:'请在统计数据中选择至少一项以获取结果',
    },
    seemore:'点击进入',
    disps:'海量媒体资源，我们为你定制',
    top5Campaigns: 'Top5产品分布',
    opition_check:'代理名称,包名,三方平台全部填写才能添加数据',
    opition_check2:'api密钥,app密钥,包名,三方平台全部填写才能添加数据',
    campaign: '产品',
    mediaSourceId: '媒体资源编号',
    mediasource: '媒体资源',
    country: '国家',
    advertiser: '广告主',
    click: '点击',
    order: '订单',
    costUsd: '花费(美元)',
    costLocalCurrency: '花费(当地货币)',
    enterFilterMediaSourceId: '请输入媒体资源编号',
    enterFilterMediaSource: '请输入媒体资源',
    enterFilterCountry: '请输入国家名称',
    enterFilterAdvertiser: '请输入广告主名称',
    enterFilteraffId:'请输入渠道编号'
}



// WEBPACK FOOTER //
// ./src/i18n/modules/aggregator/zh-cn.js